import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IMerchantSettingsListTableRecord } from '../types';
import {
  MERCHANT_SETTINGS_LIST_API_URL,
  MERCHANT_SETTINGS_LIST_QUERY_KEY,
  MERCHANT_SETTINGS_PERMISSIONS,
} from '../constants';

export default function useMerchantSettingsListQuery(tableState: Ref<ITableState>): IContextQueryResult<
  ITableDataResponse<IMerchantSettingsListTableRecord>,
  Error
> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IMerchantSettingsListTableRecord>>({
    queryKey: [MERCHANT_SETTINGS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IMerchantSettingsListTableRecord>>(
      MERCHANT_SETTINGS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: MERCHANT_SETTINGS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
